export const EXPERIENCE = [
    {
        company: 'CrowdDoing',
        location: 'San Francisco, CA',
        roles: [
            {
                role: 'AI Engineer – Remote',
                period: 'Apr 2026 – Present',
                tech: 'Python, FastAPI, Elasticsearch, Redis, Docker',
                bullets: [
                    'Improved enterprise search relevance by 18% and reduced query latency by 35% by developing a production-grade RAG pipeline using Python, FastAPI, Elasticsearch, dense embeddings, and cross-encoder reranking.',
                    'Built an incremental ingestion pipeline for 50K+ documents, implementing metadata extraction, semantic chunking, deduplication, document versioning, stale-data refresh, and role-based access controls.',
                    'Reduced LLM and retrieval costs by 25% through Redis caching, confidence-based fallbacks, retry and timeout policies, while monitoring latency, token usage, retrieval quality, and citation coverage with structured logs.',
                ],
            },
        ],
    },
    {
        company: 'Handshake AI Fellowship',
        location: 'San Francisco, CA',
        roles: [
            {
                role: 'AI Trainer – Contract',
                period: 'Oct 2025 – Present',
                tech: 'Python, NLP, RLHF',
                bullets: [
                    'Built Python data pipelines to extract, clean, and format over 10K+ conversational records for annotation and NLP fine-tuning, reducing data preparation time for downstream model training by 20%.',
                    'Curated complex prompt matrices and human preference rankings to support Reinforcement Learning from Human Feedback (RLHF) pipelines, resolving factual inaccuracies and cutting hallucination rates by 25% on internal benchmarks.',
                ],
            },
        ],
    },
    {
        company: 'Crusade Technologies',
        location: 'Austin, TX',
        roles: [
            {
                role: 'AI Engineer Intern – Remote',
                period: 'Mar 2026 – Jul 2026',
                tech: 'FastAPI, Docker, Llama 3',
                bullets: [
                    'Deployed Llama 3 services using FastAPI and Docker, improving response performance through asynchronous request handling, caching, and optimized model-serving workflows.',
                    'Improved application reliability through structured output validation, reusable prompt templates, retry logic, exception handling, and production logging for LLM requests and service failures.',
                ],
            },
        ],
    },
    {
        company: 'Rutgers University',
        location: 'New Brunswick, NJ',
        roles: [
            {
                role: 'Data Analyst',
                period: 'Sep 2024 – Oct 2025',
                bullets: [
                    'Automated ETL pipelines and natural language reporting using Python and SQL to summarize model outputs for department leadership, saving 40% in weekly administrative reporting hours.',
                    'Trained a Prophet time-series regression model to forecast campus service demand, improving peak-period prediction accuracy by 15% through historical data backtesting.',
                    'Supported backend logistics for university-wide correspondence, applying operational precision to route, track, and deliver high-volume mail across departments.',
                ],
            },
            {
                role: 'International Student Orientation Leader',
                period: 'Apr 2024 – Sep 2024',
                bullets: [
                    'Acted as a peer systems analyst, spotting confusion patterns in student questions and informing ISSS staff to update documentation and pre-arrival material.',
                    'Redesigned orientation flow using feedback loops and real-time insights from prior sessions, streamlining day-one operations like ID registration and legal check-ins.',
                ],
            },
            {
                role: 'Graduate Student Assistant',
                period: 'May 2024 – Aug 2024',
                bullets: [
                    'Optimized the processing and analysis of research-grade plant tissue samples, increasing lab throughput by 15% as measured by output reports, by coordinating with laboratory staff to refine sample preparation techniques and maintaining meticulous digital records in Excel.',
                ],
            },
        ],
    },
    {
        company: 'Infosys Limited',
        location: 'India',
        roles: [
            {
                role: 'Software Engineer',
                period: 'Aug 2021 – Jul 2023',
                tech: 'Python, SQL, Oracle, PostgreSQL, ETL, Data Validation, Power BI, Git, Agile',
                bullets: [
                    'Engineered an intelligent anomaly detection system for telecom fraud by deploying an Isolation Forest model, reducing manual audit overhead by 45% and flagging $40K+ in annual revenue leakage.',
                    'Optimized data-centric AI pipelines using PySpark to ensure high-fidelity training data for healthcare diagnostic models, improving model robustness against edge-case noise by 25%.',
                    'Built a real-time data validation framework using Great Expectations to mitigate model drift and data inconsistencies, reducing production retraining errors by 35%.',
                    'Deployed containerized inference microservices for real-time model scoring via FastAPI and Docker, maintaining 99.9% uptime for cross-functional business intelligence teams.',
                    'Collaborated with QA and Product teams to translate complex business logic into scalable AI solutions, ensuring alignment between model KPIs and operational ROI.',
                ],
            },
        ],
    },
] as const;
